// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__vFGBc","inner":"Footer_inner__3okWp"};